const dateTimeFormatter = new Intl.DateTimeFormat('th', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
export function formatDateTime(date) {
  return dateTimeFormatter.format(date);
}

// Pinned to Asia/Bangkok so the value does not shift with the operator's machine.
const dateTimeBangkokFormatter = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Bangkok' });
export function formatDateTimeBangkok(date) {
  return dateTimeBangkokFormatter.format(date);
}

export function calcPrice({ booking, now }) {
  if (!booking.startTime)
    return {
      chargedSecond: 0,
      totalEnergyKwh: 0,
      priceByPower: 0,
      priceByDuration: 0,
      priceByPenalty: 0,
      price: 0,
    };

  const startTime = booking.startTime ?? now;
  const stopTime = booking.stopTime ?? now;
  const totalEnergyKwh = booking.totalEnergyKwh ?? 0;
  const avaliableAt = booking.avaliableAt ?? now;
  const fullAt = booking.fullAt ?? now;

  const chargedSecond = (stopTime.getTime() - startTime.getTime()) / 1000;
  const penaltyMinute = Math.max(0, (avaliableAt.getTime() - stopTime.getTime()) / (1000 * 60) - 5);
  const penaltyMinuteFull = Math.max(0, (avaliableAt.getTime() - fullAt.getTime()) / (1000 * 60) - booking.penaltyDCFullDelayMin);

  const isPriceByPower = booking.method === 'KW' || booking.method === 'HOUR_KW';
  const isPriceByDuration = booking.method === 'HOUR' || booking.method === 'HOUR_KW';
  const isPriceByHour = isPriceByDuration && booking.calculateMethod === 'BAHT_HRS';
  const isPriceByMin = isPriceByDuration && booking.calculateMethod === 'BAHT_MIN';
  const isDC = [4].includes(booking.connectorTypeId);

  let priceByPower = isPriceByPower ? booking.bahtPerKwh * totalEnergyKwh : 0;
  const priceByHour = isPriceByHour ? booking.bahtPerHour * Math.max(1, Math.ceil((chargedSecond - 600) / 3600)) : 0;
  const priceByMin = isPriceByMin ? booking.bahtPerHour / 60 * Math.ceil(chargedSecond / 60) : 0;
  let priceByDuration = priceByHour + priceByMin;
  let priceByPenalty = booking.penaltyBahtPerMin * Math.ceil(penaltyMinute) + (isDC ? booking.penaltyDCFullBahtPerMin * Math.ceil(penaltyMinuteFull) : 0);

  if (typeof booking.priceByPower === 'number') priceByPower = booking.priceByPower;
  if (typeof booking.priceByDuration === 'number') priceByDuration = booking.priceByDuration;
  if (typeof booking.priceByPenalty === 'number') priceByPenalty = booking.priceByPenalty;
  let price = priceByPower + priceByDuration + priceByPenalty;

  if (typeof booking.adminAmount === 'number') price = booking.adminAmount;

  return {
    chargedSecond,
    totalEnergyKwh,
    priceByPower,
    priceByDuration,
    priceByPenalty,
    price,
    adminPrice:
      typeof booking.adminAmount === 'number' ||
      typeof booking.priceByPower === 'number' ||
      typeof booking.priceByDuration === 'number' ||
      typeof booking.priceByPenalty === 'number',
    adminPriceByPower: typeof booking.priceByPower === 'number',
    adminPriceByDuration: typeof booking.priceByDuration === 'number',
    adminPriceByPenalty: typeof booking.priceByPenalty === 'number',
  };
}

export function formatSecond(second) {
  if (second < 0) return '00:00:00';

  let minute = Math.floor(second / 60);
  second -= 60 * minute;

  let hour = Math.floor(minute / 60);
  minute -= 60 * hour;

  return `${hour.toFixed().padStart(2, '0')}:${minute.toFixed().padStart(2, '0')}:${second.toFixed().padStart(2, '0')}`;
}

function createFormat(formatter, defaultValue) {
  return (value) => {
    if (value) return formatter[value];
    return defaultValue;
  };
}
function createList(formatter) {
  return Object.entries(formatter).map(([name, value]) => ({ name: name, value: value }));
}
function createIs(formatter) {
  return (value) => typeof value === 'string' && !!formatter[value];
}

const formatterPaymentMethod = {
  qr: "QR Promptpay",
  credit: "Credit / Debit Card",
  truemoney: "True Money Wallet",
  linepay: "Line Pay",
  zero: "Zero",
  manual: "Manual",
};
export const formatPaymentMethod = createFormat(formatterPaymentMethod, null);
export const listPaymentMethod = createList(formatterPaymentMethod);
export const isPaymentMethod = createIs(formatterPaymentMethod);

const formatterUserType = {
  'mobile': 'Mobile',
  'ruejai': 'Ruejai',
};
export const formatUserType = createFormat(formatterUserType, null);
export const listUserType = createList(formatterUserType);
export const isUserType = createIs(formatterUserType);

const formatterAdminRole = {
  'admin': 'Admin',
  'merchant': 'Cluster',
  'party': 'Group',
  'landlord': 'Site',
  'callcenter': 'Call center',
  'station': 'Customer station',
  'marketting': 'Marketing',
};
export const formatAdminRole = createFormat(formatterAdminRole, null);
export const listAdminRole = createList(formatterAdminRole);
export const isAdminRole = createIs(formatterAdminRole);

const formatterPriceCalculateMethod = {
  'BAHT_MIN': 'BAHT_MIN',
  'BAHT_HRS': 'BAHT_HRS',
};
export const formatPriceCalculateMethod = createFormat(formatterPriceCalculateMethod, null);
export const listPriceCalculateMethod = createList(formatterPriceCalculateMethod);
export const isPriceCalculateMethod = createIs(formatterPriceCalculateMethod);

const formatterPriceMethod = {
  'HOUR': 'HOUR',
  'KW': 'KW',
  'HOUR_KW': 'HOUR_KW',
};
export const formatPriceMethod = createFormat(formatterPriceMethod, null);
export const listPriceMethod = createList(formatterPriceMethod);
export const isPriceMethod = createIs(formatterPriceMethod);

const formatterPromotionType = {
  'landlord': 'Landlord',
  'point': 'Green Point',
  'discount': 'Discount',
};
export const formatPromotionType = createFormat(formatterPromotionType, null);
export const listPromotionType = createList(formatterPromotionType);
export const isPromotionType = createIs(formatterPromotionType);

const formatterPageType = {
  'terms': 'Terms and condition',
  'privacy': 'Privacy policy',
  'guide': 'Guide',
};
export const formatPageType = createFormat(formatterPageType, null);
export const listPageType = createList(formatterPageType);
export const isPageType = createIs(formatterPageType);

const formatterPowerType = {
  'AC': 'AC',
  'DC': 'DC',
};
export const formatPowerType = createFormat(formatterPowerType, null);
export const listPowerType = createList(formatterPowerType);
export const isPowerType = createIs(formatterPowerType);

const formatterLandlordBusinessHoursType = {
  '24H': 'Always Open',
  'closed': 'Closed',
  'period': 'Open on Selected Hours',
  'comingsoon': 'Coming Soon',
  'maintenance': 'Maintenance',
};
export const formatLandlordBusinessHoursType = createFormat(formatterLandlordBusinessHoursType, null);
export const listLandlordBusinessHoursType = createList(formatterLandlordBusinessHoursType);
export const isLandlordBusinessHoursType = createIs(formatterLandlordBusinessHoursType);

const formatterBookingStatus = {
  'created': { text: 'Created', color: '#B9B9B9' },
  'started': { text: 'Started', color: '#B9B9B9' },
  'charging': { text: 'Charging', color: '#3699FF' },
  'charged': { text: 'Charged', color: '#3699FF' },
  'stopped': { text: 'Unpaid', color: '#FFB509' },
  'cancelled': { text: 'Cancelled', color: '#EB5757' },
  'paid': { text: 'Paid', color: '#55B491' },
};
export const formatBookingStatus = createFormat(formatterBookingStatus, { text: 'Unknown', color: 'white' });
export const listBookingStatus = createList(formatterBookingStatus);
export const isBookingStatus = createIs(formatterBookingStatus);
